import {
  viabilitySchema,
  viabilitesSchema,
  viabilityDeletionSchema,
} from "@/schemas/viabilities";

import { getAppUrl } from "@/helper/url";

import type { Viability, ViabilityFilter } from "@/types";

const url = `${getAppUrl()}/api/viabilities`;

export const fetchViabilities = async (filter: ViabilityFilter) => {
  try {
    const response = await fetch(
      filter.id ? `${url}?numero_do_leilao=${filter.id}` : url
    );

    if (!response.ok) {
      throw new Error("Falha ao buscar análises de matrículas");
    }

    const data = await response.json();

    return viabilitesSchema.parse(data);
  } catch (error) {
    console.error("Erro ao buscar viabilidades financeiras:", error);
    throw new Error(
      error instanceof Error
        ? error.message
        : "Falha ao buscar viabilidades financeiras"
    );
  }
};

export const fetchViability = async (id: string) => {
  try {
    const response = await fetch(`${url}/${id}`);

    if (!response.ok) {
      throw new Error("Falha ao buscar detalhes da viabilidade financeira");
    }

    const data = await response.json();

    return viabilitySchema.parse(data);
  } catch (error) {
    console.error("Erro ao buscar detalhes da viabilidade financeira:", error);
    throw new Error(
      error instanceof Error
        ? error.message
        : "Falha ao buscar detalhes da viabilidade financeira"
    );
  }
};

export const postViability = async (property: Viability) => {
  const response = await fetch(`${url}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(property),
  });

  if (!response.ok) {
    throw new Error("Falha ao salvar viabilidade financeira");
  }

  const data = await response.json();

  return viabilitySchema.parse(data);
};

export const patchViability = async (
  data: Omit<Viability, "criado_em" | "usuario_id">
) => {
  try {
    const response = await fetch(`${url}/${data.id}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(
        errorData.error || "Falha ao atualizar viabilidade financeira"
      );
    }

    const responseData = await response.json();
    return viabilitySchema.parse(responseData);
  } catch (error) {
    console.error(`Erro ao atualizar viabilidade financeira:`, error);
    throw new Error(
      error instanceof Error
        ? error.message
        : "Falha ao atualizar viabilidade financeira"
    );
  }
};

export const deleteViability = async (id: string) => {
  try {
    const response = await fetch(`${url}/${id}`, {
      method: "DELETE",
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(
        errorData.error || "Falha ao remover viabilidade financeira"
      );
    }

    const responseData = await response.json();
    return viabilityDeletionSchema.parse(responseData);
  } catch (error) {
    console.error(`Erro ao remover viabilidade financeira ID: ${id}:`, error);
    throw new Error(
      error instanceof Error
        ? error.message
        : "Falha ao remover viabilidade financeira"
    );
  }
};
